export const getSetupEntryPath = (jobArchitectureId: string): string =>
    `/job-architecture-v2/${jobArchitectureId}/setup-dialog/overview`;
